import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { connect } from 'react-redux';
import { history } from 'store';
import { getPublishMeta, publishRoster } from 'actions/rosterActions';
import HeaderBar from 'components/headerBar/header-bar';
import ToolBar from 'components/toolBar/tool-bar';
import {
  Button, Checkbox, Col, DatePicker, Icon, message, Modal, Row, Spin, Tooltip
} from 'antd';

const { RangePicker } = DatePicker;
const Confirm = Modal.confirm;

class RosterPublish extends React.Component {
  constructor(props) {
    super(props);

    this.handlePublishTypeChange = this.handlePublishTypeChange.bind(this);
    this.handlePublishRangeChange = this.handlePublishRangeChange.bind(this);
    this.handlePublishClick = this.handlePublishClick.bind(this);
    this.handleBackClick = this.handleBackClick.bind(this);

    this.state = {
      publishEntireDraft: true,
      publishRangeValue: props.defaultDate
    };
  }

  componentDidMount() {
    const { match, dispatchGetPublishMeta } = this.props;
    const { params } = match;
    const versionId = params.id;

    if (!versionId) {
      history.push('/roster/list/');
    }
    else {
      dispatchGetPublishMeta(versionId);
    }
  }

  publish() {
    const { match, dispatchPublishRoster, dispatchGetPublishMeta } = this.props;
    const { publishEntireDraft, publishRangeValue } = this.state;
    const { params } = match;
    const versionId = params.id;
    const publishRange = (publishEntireDraft ? [null, null] : _.cloneDeep(publishRangeValue));

    dispatchPublishRoster(versionId, publishRange)
      .then(
        () => {
          dispatchGetPublishMeta(versionId, publishRange);
          message.success('Draft published successfully.');
        },
        () => {
          message.error('Draft publish failed.');
        }
      );
  }

  handlePublishTypeChange() {
    this.setState(prevState => ({
      publishEntireDraft: !prevState.publishEntireDraft
    }), () => {
      const { match, dispatchGetPublishMeta } = this.props;
      const { publishEntireDraft, publishRangeValue } = this.state;
      const { params } = match;
      const versionId = params.id;
      const publishRange = (publishEntireDraft ? [null, null] : _.cloneDeep(publishRangeValue));

      dispatchGetPublishMeta(versionId, publishRange);
    });
  }

  handlePublishRangeChange(dateRange) {
    const { match, dispatchGetPublishMeta } = this.props;
    const { params } = match;
    const versionId = params.id;
    let parsedDateRange = [null, null];
    if (dateRange.length !== 0) {
      parsedDateRange = dateRange;
    }
    dispatchGetPublishMeta(versionId, parsedDateRange);
    this.setState({ publishRangeValue: parsedDateRange });
  }

  handlePublishClick() {
    const self = this;
    const { publishMeta } = this.props;

    const content = (
      <div>
        <p>
          Are you sure you want to publish draft
          <br />
          <b>
            &quot;
            {publishMeta.data.name}
            &quot;
          </b>
          ?
        </p>
        <p>This action cannot be undone.</p>
      </div>
    );

    Confirm({
      title: 'Confirm Publish',
      content,
      okText: 'Publish',
      cancelText: 'Cancel',
      onOk() {
        self.publish();
      },
      onCancel() {

      }
    });
  }

  handleBackClick() {
    const { match, location } = this.props;
    const { params } = match;
    history.push(`/roster/detail/${params.id}${location.search}`);
  }

  renderToolbar(isloading) {
    return (
      <ToolBar>
        <ToolBar.Right>
          <Tooltip title="Publish" placement="bottom">
            <Button
              type="primary"
              size="small"
              icon="safety"
              disabled={isloading}
              loading={isloading}
              onClick={this.handlePublishClick}
            >
              Publish
            </Button>
          </Tooltip>
          <Tooltip title="Save" placement="bottom">
            <Button size="small" icon="caret-left" disabled={isloading} loading={isloading} onClick={this.handleBackClick}>
              Back
            </Button>
          </Tooltip>
        </ToolBar.Right>
      </ToolBar>
    );
  }

  render() {
    const { publishMeta } = this.props;
    const { publishEntireDraft, publishRangeValue } = this.state;
    const { inFlight, data } = publishMeta;
    const draftName = data.name === undefined ? '' : data.name;

    return (
      <div className="bhp-roster-publish bhp-container">
        <Spin indicator={<Icon type="loading" spin />} tip="Loading..." spinning={inFlight}>
          <HeaderBar title={`Publish Draft: ${draftName}`} toolbar={this.renderToolbar(inFlight)} />
          <div className="bhp-form-container">
            <div className="bhp-form">
              <Row>
                <Col span={12}>
                  <h4>Publication Range</h4>
                  <Checkbox checked={publishEntireDraft} onChange={this.handlePublishTypeChange}>
                    Publish entire draft
                  </Checkbox>
                  <RangePicker
                    showTime={false}
                    format="DD-MM-YYYY"
                    value={publishEntireDraft ? [null, null] : publishRangeValue}
                    disabled={publishEntireDraft}
                    onChange={this.handlePublishRangeChange}
                  />
                  <h4>Publication Impact</h4>
                  <table>
                    <thead>
                      <tr>
                        <th>Name</th>
                        <th>Date range impact</th>
                        <th>Entire impact</th>
                        <th>Description</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>Additions</td>
                        <td>{publishMeta.data.adds_dt}</td>
                        <td>{publishMeta.data.adds_all}</td>
                        <td>New assignments to be added</td>
                      </tr>
                      <tr>
                        <td>Modifications</td>
                        <td>{publishMeta.data.mods_dt}</td>
                        <td>{publishMeta.data.mods_all}</td>
                        <td>Existing published assignments modified in this draft</td>
                      </tr>
                      <tr>
                        <td>Deletions</td>
                        <td>{publishMeta.data.dels_dt}</td>
                        <td>{publishMeta.data.dels_all}</td>
                        <td>Published assignments to be deleted</td>
                      </tr>
                    </tbody>
                  </table>
                </Col>
              </Row>
            </div>
          </div>
        </Spin>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  publishMeta: state.api.publishStatus
});

const mapDispatchToProps = dispatch => ({
  dispatchGetPublishMeta(versionId, dateRange = [null, null]) {
    dispatch(getPublishMeta(versionId, dateRange));
  },
  dispatchPublishRoster(versionId, dateRange) {
    return dispatch(publishRoster(versionId, dateRange));
  }
});

RosterPublish.propTypes = {
  dispatchGetPublishMeta: PropTypes.func.isRequired,
  dispatchPublishRoster: PropTypes.func.isRequired,
  publishMeta: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
  defaultDate: PropTypes.array
};

RosterPublish.defaultProps = {
  defaultDate: [null, null]
};

export default connect(mapStateToProps, mapDispatchToProps)(RosterPublish);
